<template>
  <ad-banner-detail :is-edit='true'>
  </ad-banner-detail>
</template>

<script>
import AdBannerDetail from '../components/AdBannerDetail'
export default {
  name: 'EditAdBanner',
  components: {
    AdBannerDetail
  }
}
</script>

